import CaseTaskBadgeForCaseStatus from "@/components/Table/MrtCaseFilters/CaseTaskBadgeForCaseStatus.tsx";
import NotificationBadgeForCaseStatus from "@/components/Table/MrtCaseFilters/NotificationBadgeForCaseStatus.tsx";
import TabBadges from "@/components/Table/MrtCaseFilters/TabBadges.tsx";
import { Button, ButtonGroup } from "@mui/material";

type Props = {
    selectedTab: string;
    setSelectedTab: (selectedTab: string) => void;
};

const AttorneyLitigationFilters = ({ selectedTab, setSelectedTab }: Props) => {
    return (
        <ButtonGroup aria-label="Basic button group" fullWidth sx={{ mb: 2 }}>
            <Button
                onClick={() => setSelectedTab("")}
                variant={selectedTab === "" ? "contained" : "outlined"}
                sx={{ px: 1 }}
            >
                All Cases
                <TabBadges />
            </Button>
            <Button
                onClick={() => setSelectedTab("Litigation")}
                variant={selectedTab === "Litigation" ? "contained" : "outlined"}
            >
                Litigation
                <NotificationBadgeForCaseStatus caseStatus="Litigation" />
                <CaseTaskBadgeForCaseStatus caseStatus="Litigation" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Mediation")}
                variant={selectedTab === "Mediation" ? "contained" : "outlined"}
            >
                Mediation
                <NotificationBadgeForCaseStatus caseStatus="Mediation" />
                <CaseTaskBadgeForCaseStatus caseStatus="Mediation" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Hold Harmless")}
                variant={selectedTab === "Hold Harmless" ? "contained" : "outlined"}
            >
                Hold Harmless
                <NotificationBadgeForCaseStatus caseStatus="Hold Harmless" />
                <CaseTaskBadgeForCaseStatus caseStatus="Hold Harmless" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Checks Printed")}
                variant={selectedTab === "Checks Printed" ? "contained" : "outlined"}
            >
                Checks Printed
                <NotificationBadgeForCaseStatus caseStatus="Checks Printed" />
                <CaseTaskBadgeForCaseStatus caseStatus="Checks Printed" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Disbursed")}
                variant={selectedTab === "Disbursed" ? "contained" : "outlined"}
            >
                Disbursed
                <NotificationBadgeForCaseStatus caseStatus="Disbursed" />
                <CaseTaskBadgeForCaseStatus caseStatus="Disbursed" />
            </Button>
        </ButtonGroup>
    );
};

export default AttorneyLitigationFilters;
